import { ComponentProps, ReactElement, ReactNode } from 'react';
import PassengersIcon from '../../../../assets/icons/passenger.svg';
import BusinessIcon from '../../../../assets/icons/handshake.svg';
import CareersIcon from '../../../../assets/icons/suitcase.svg';
import OxdIcon from '../../../../assets/icons/oxd.svg';
import {
	BusinessPageId,
	CareersPageId,
	OXDPageId,
	PassengersPageId,
} from '../../../../features/app/pages/domain/constants/PageId';
import { IAsset } from '../../../../contentful';

interface ISiteSectionIconProps extends ComponentProps<'svg'> {
	id: string;
	icon?: IAsset;
	inlineSvg?: ReactNode;
}

const fallbackIconMap: Record<
	string,
	(props: ComponentProps<'svg'>) => ReactElement
> = {
	[PassengersPageId.Home]: (props) => <PassengersIcon {...props} />,
	[BusinessPageId.Home]: (props) => <BusinessIcon {...props} />,
	[CareersPageId.Home]: (props) => <CareersIcon {...props} />,
	[OXDPageId.Home]: (props) => <OxdIcon {...props} />,
};

export function SiteSectionIcon({
	id,
	icon,
	inlineSvg,
	...props
}: ISiteSectionIconProps) {
	const { url } = icon?.fields.file || {};

	if (inlineSvg) return inlineSvg as JSX.Element;

	if (url) {
		return <img src={url} className={props.className} alt="" />;
	}

	const FallbackIcon = fallbackIconMap[id];
	return FallbackIcon ? FallbackIcon(props) : null;
}
